import { cashPlanSchema } from "../../../shared/account-finance/cash-plan-contract";
import type { CashPlan } from "../../../shared/account-finance/cash-plan-contract";

export const cashPlanFrequencies = { once: "Tek sefer", weekly: "Her hafta", monthly: "Her ay" };
export type CashPlanFormValues = {
  name: string; category: string; amount: string; currency: string; direction: string;
  date: string; endDate: string; frequency: string;
};
export type CashPlanFormErrors = Partial<Record<keyof CashPlanFormValues, string>>;

/** Turkish thousands/decimal separators and the previously accepted plain decimal input. */
export function parseCashPlanMoney(input: string): string {
  const value = input.trim();
  const grouped = /^\d{1,3}(?:\.\d{3})+(?:,\d{1,2})?$/u.test(value);
  if (!grouped && !/^\d+(?:[.,]\d{1,2})?$/u.test(value))
    throw new Error("Tutarı 12.500,50 veya 12500,50 biçiminde girin.");
  const normalized = (grouped ? value.replaceAll(".", "") : value).replace(",", ".");
  const [whole, fraction = ""] = normalized.split(".");
  const cents = BigInt(whole) * 100n + BigInt(fraction.padEnd(2, "0"));
  if (cents > 9_999_999_999_999_999n) throw new Error("Tutar desteklenen sınırı aşıyor.");
  return String(cents);
}
export function formatCashPlanMoney(cents: string): string {
  const value = BigInt(cents);
  return `${(value / 100n).toLocaleString("tr-TR")},${String(value % 100n).padStart(2, "0")}`;
}
export function validateCashPlanForm(values: CashPlanFormValues, id: string):
  { plan: CashPlan; errors: null } | { plan: null; errors: CashPlanFormErrors } {
  let amount: string;
  try { amount = parseCashPlanMoney(values.amount); }
  catch (failure) { return { plan: null, errors: { amount: failure instanceof Error ? failure.message : "Tutarı kontrol edin." } }; }
  const parsed = cashPlanSchema.safeParse({ id, name: values.name, category: values.category, amount,
    currency: values.currency, direction: values.direction, startDate: values.date, endDate: values.endDate || null,
    frequency: values.frequency, active: true });
  if (parsed.success) return { plan: parsed.data, errors: null };
  const errors: CashPlanFormErrors = {};
  const fieldNames: Record<string, keyof CashPlanFormValues> = { name: "name", category: "category", amount: "amount",
    currency: "currency", direction: "direction", startDate: "date", endDate: "endDate", frequency: "frequency" };
  const messages: CashPlanFormErrors = { name: "Plan adı 2–100 karakter olmalı.", category: "Bir kalem seçin.",
    amount: "Geçerli bir tutar girin.", currency: "Bir döviz seçin.", direction: "Giriş veya çıkış seçin.",
    date: "Geçerli bir tarih girin.", endDate: "Bitiş tarihi başlangıçtan önce olamaz.", frequency: "Tekrar düzenini seçin." };
  for (const issue of parsed.error.issues) {
    const field = fieldNames[String(issue.path[0])];
    if (field) errors[field] = messages[field];
  }
  return { plan: null, errors };
}
